import Home from "../components/home/Home";
import Templatespreview from "../components/templates/Templatespreview";
import PrinterDetails from "../components/printer/PrinterDetails";
import ErrorCode from "../components/printer/ErrorCode/ErrorCode";
import AddPrinterModel from "../components/printer/AddPrinterModel/AddPrinterModel";
import AddPrinter from "../components/printer/AddPrinter/AddPrinter";
import EditPrinterModal from "../components/printer/EditPrinterModel/EditPrinterModel";
import EditPrinter from "../components/printer/EditPrinter/EditPrinter";
import AddTemplate from "../components/templates/AddTemplate/AddTemplate";
import EditTemplate from "../components/templates/AddTemplate/EditTemplate";
import Logout from "../components/logout/logout";
import PrinterStatus from "../components/printer/PrinterStatus/PrinterStatus";
import AddLocation from "../components/location/AddLocation/Location";
import EditLocation from "../components/location/EditLocation/EditLocation";
import SilentCallback from "../components/auth/silentCallback";
import Login from "../components/login/Login";
import PageNotFound from "../components/PageException/pageNotFound";
import CallbackComponent from "../components/Callback/callback";

interface RouteConfig {
  path: string;
  element: React.ComponentType;
}

const routesConfig: RouteConfig[] = [
  { path: "/", element: Login },
  { path: "/home", element: Home },
  { path: "/templates", element: Templatespreview },
  { path: "/printerdetails", element: PrinterDetails },
  { path: "/errorcode", element: ErrorCode },
  { path: "/login", element: Login },
  { path: "/addprintermodel", element: AddPrinterModel },
  { path: "/addprinter", element: AddPrinter },
  { path: "/editprintermodel/:Id", element: EditPrinterModal },
  { path: "/editprinter/:Id", element: EditPrinter },
  { path: "/addtemplate", element: AddTemplate },
  { path: "/edittemplate/:Id", element: EditTemplate },
  { path: "/logout", element: Logout },
  { path: "/printerstatus", element: PrinterStatus },
  { path: "/addlocation", element: AddLocation },
  { path: "/editlocation/:Id", element: EditLocation },
  { path: "/silent-callback", element: SilentCallback },
  { path: "*", element: PageNotFound },
  { path: "/callback", element: CallbackComponent }
];

export default routesConfig;
